<template>
  <div class="environmental">
    <div class="container">
      <h1>排污/环保管家</h1>
      <p class="subtitle">一站式环保解决方案</p>
      
      <div class="env-section">
        <h2 class="section-title">环保管家业务介绍</h2>
        <div class="section-content">
          <div class="article-content">
            <p>
              2016 年 4 月，环保部下发《关于积极发挥环境保护作用促进供给侧结构性改革的指导意见》，积极推进环境咨询服务业发展，鼓励有条件的工业园区聘请第三方专业环保服务公司作为"环保管家"，提供监测、监理、环保设施建设运营、污染治理等一体化环保服务和解决方案。
            </p>
            <p>
              2017 年 8 月，环保部出台《关于推进环境污染第三方治理的实施意见》，继续推动建立排污者付费、第三方治理与排污许可证制度有机结合的污染治理新机制，鼓励第三方治理单位在环境污染治理公共设施建设和工业园区污染治理领域，发挥专业作用。
            </p>
            <p>
              隆之智环保正式发布"环保管家"服务框架，在第三方VOCs 综合管控服务的基础上再度升级，为一个企业、园区、区域提供定制化、乃至全产业链的"绿色生产+环保咨询+ 环境检测"第三方专业服务，帮助园区和企业优化环保管理机制，高效利用环保资金，降低环保成本，有效规避环境风险，享受绿色生产红利，树立园区和企业整体绿色环保形象。
            </p>
            <p>
              公司秉承"环保管家"式服务理念，不断提高第三方服务水平。项目负责人与企业建立一对一服务关系。建立项目反馈和长期合作机制，实时为企业提供各类环保咨询服务。隆之智骨干在环保领域有着深入的行业研究和丰富的从业经验，业务合作单位包括各类央企、大型国企及企事业单位，业务范围涵盖山东及周边省份，已有较完备的环保大数据基础。
            </p>
          </div>
        </div>
      </div>

      <div class="env-section">
        <h2 class="section-title">排污许可管家业务介绍</h2>
        <div class="section-content">
          <div class="article-content">
            <p>
              排污许可证作为企业环保执法情况的一个重要依据，其必要性及合规性将愈发重要。排污许可证的申领及后续管理将愈发严格。因此，对企业来说，排污许可证审核通过并不意味着就可以高枕无忧了，其后续管理和执行更为重要和烦琐。在排污许可证申请及后续管理方面，隆之智已在全国众多省份积累了丰富的经验，特面向全国推广排污许可证管家业务：
            </p>
            <div class="service-image">
              <img :src="require('../assets/22.jpg')" alt="排污许可证管家" class="service-main-image" />
            </div>

            <h3 class="section-subtitle">一、为环保主管部门提供排污许可证第三方技术审核服务及咨询服务</h3>
            <div class="service-list">
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证申请后的第三方技术审核</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证证后监管第三方技术审核</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">协助开阵排污许可证第三方现场审核</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证核发第三方技术评估</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">污染物排放量第三方核算</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">承接环保部门排污许可证技术课题</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证技术及管理培训</p>
                </div>
              </div>
            </div>

            <h3 class="section-subtitle">二、为园区/企业提供排污许可证技术咨询服务</h3>
            <div class="service-list">
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证申请与变更</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证执行报告编制</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证执行情况外部审核及整改协助</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">污染源监测信息管理共享平台信息填报</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">环境统计数据核算与填报</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">环保税数据核算与填报</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证试填报（申请登记）服务</p>
                </div>
              </div>
              <div class="service-item">
                <div class="service-details">
                  <p class="service-desc">排污许可证申领及证后管理培训</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppEnvironmental'
}
</script>

<style scoped>
.environmental {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  margin-bottom: 60px;
}

@media screen and (max-width: 768px) {
  .environmental {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 480px) {
  .environmental {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }
}

.env-section {
  margin-bottom: 80px;
}

.section-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #42b983;
}

.section-content p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 40px;
}

@media screen and (max-width: 768px) {
  .env-section {
    margin-bottom: 60px;
  }

  .section-title {
    font-size: 24px;
  }

  .section-content p {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .env-section {
    margin-bottom: 40px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-content p {
    font-size: 13px;
  }
}

.service-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 25px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.service-icon {
  flex-shrink: 0;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.service-details {
  flex: 1;
}

.service-details h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.service-details p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* 文章元信息样式 */
.article-meta {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #999;
}

.publish-date {
  display: inline-block;
}

/* 文章内容样式 */
.article-content {
  margin-bottom: 40px;
}

.article-content p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 25px;
  text-align: justify;
}

/* 小节标题样式 */
.section-subtitle {
  font-size: 22px;
  color: #333;
  margin: 40px 0 25px;
  font-weight: 600;
  padding-left: 15px;
  position: relative;
}

.section-subtitle::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 25px;
  background-color: #42b983;
  border-radius: 2px;
}

/* 服务描述样式 */
.service-desc {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  margin: 0;
  font-weight: 500;
}

/* 服务图片样式 */
.service-image {
  margin: 30px 0;
}

.service-main-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  background-color: #f9f9f9;
}



@media screen and (max-width: 768px) {
  .service-list {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .service-item {
    padding: 20px;
  }

  .service-icon {
    width: 50px;
    height: 50px;
  }

  .service-icon svg {
    width: 36px;
    height: 36px;
  }

  .service-details h3 {
    font-size: 16px;
  }

  .service-details p {
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .service-list {
    grid-template-columns: 1fr;
  }

  .service-item {
    padding: 15px;
  }

  .service-icon {
    margin-bottom: 15px;
  }

  .service-details h3 {
    font-size: 15px;
  }

  .service-details p {
    font-size: 12px;
  }
}
</style>